import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import MailStore from 'stores/inbox/MailStore';
import FolderStore from 'stores/inbox/FolderStore';
import ViewItemToolbar from 'components/inbox/mail-toolbar/ViewItemToolbar';
import MatchedRulePopoverContainer from 'components/inbox/mail-toolbar/MatchedRulePopoverContainer';
import FolderActions from 'actions/inbox/FolderActions';
import {getNumberQueryParam} from 'utils/getQueryParam';
import CallCardContainer from '@components/call-card/CallCardContainer';
import {CallCardVariant} from '@components/call-card/CallCard.types';
import MailActions from 'actions/inbox/MailActions';
import {RouterLocation} from '@store/@types/util/ReactRouter';
import {FileUploadId} from 'records/CoachingReviewFileUpload';
import './InboxCallCardPage.sass';

interface InboxCallCardPageProps {
  location: RouterLocation;
  params: {
    callId: FileUploadId;
    itemId: string; // InboxItemId needs to be parsed
  };
}

/**
 * Share the majority of this page with the CallCardPage - we override
 * the header to replace it with our own (inbox ribbon)
 */
@connectToStores
export default class InboxCallCardPage extends React.Component<
  InboxCallCardPageProps & ReturnType<typeof InboxCallCardPage.getPropsFromStores>
> {
  static getStores() {
    return [MailStore, FolderStore];
  }

  static getPropsFromStores(props: InboxCallCardPageProps) {
    const ruleId = getNumberQueryParam(location, 'ruleId');
    const folderId = getNumberQueryParam(location, 'folderId');
    const inboxItemId = parseInt(props.params.itemId, 10);
    return {
      mail: MailStore.getState().mail,
      folders: FolderStore.getState().folders,
      ruleId,
      inboxItemId,
      folderId,
    };
  }

  componentDidMount() {
    // Mark inbox items as read
    MailActions.markCallAsRead(this.props.params.callId);
    FolderActions.fetchFolders.defer();
  }

  render() {
    const {location, folders, mail, inboxItemId, ruleId, folderId, params} = this.props;

    const inboxItem = mail.get(inboxItemId);
    const isViewingTrash = folders.find(folder => folder.isTrash())?.id === folderId;
    const hideActionButtons = location.state?.hideActionButtons;

    return (
      <div className="inbox-call-card-page">
        <ViewItemToolbar
          location={location}
          inboxItem={inboxItem}
          showMarkAsRead={false}
          folders={folders}
          showMoveToTrash={!isViewingTrash && !hideActionButtons}
          showPin={!hideActionButtons}
          showMoveToFolder={!hideActionButtons}>
          {(ruleId || inboxItem) && (
            <MatchedRulePopoverContainer inboxItem={inboxItem} ruleId={ruleId} />
          )}
        </ViewItemToolbar>
        <CallCardContainer
          callId={params.callId}
          location={location}
          variant={CallCardVariant.INBOX}
        />
      </div>
    );
  }
}
